import React from 'react';

const About = () => {
    return (
        <div>
            <h2>NetAlly Wi-Fi6测试仪 模拟器</h2>
            <br>
            </br>
            <p>版本：v.1.0</p>
            <p>功能说明：</p>
            <p>&nbsp;&nbsp;|--1、目前仅开放SSIDs功能</p>
            <p>&nbsp;&nbsp;|--2、可配合AC仿真平台进行实验</p>
            <p>&nbsp;&nbsp;|--3、使用ACG3上传真实测试数据</p>
            <p>&nbsp;</p>
            <p>更新日志：</p>
            <p>2024/06/14</p>
            <p>&nbsp;&nbsp;|--&nbsp;·更新APs、信道利用率界面</p>
            <p>2024/06/18</p>
            <p>&nbsp;&nbsp;|--&nbsp;·完善APs界面,可以根据信号强度、名称、SSID数量等排序</p>
            <p>&nbsp;&nbsp;|--&nbsp;·增加BSSIDs界面，可以根据不同参数进行排序</p>
            <p>&nbsp;</p>
            <p>2024/07/08</p>   
            <p>&nbsp;&nbsp;|--&nbsp;·完善BSSIDs的性能和速率菜单</p>
            <p>计划</p>   
            <p>&nbsp;&nbsp;|--&nbsp;·完善筛选等更多功能</p>
            <p>&nbsp;</p>
            <p>关于模拟器任何问题请联系Husky.Chen@langkun.com</p>
        </div>
    );
};

export default About;